// extracted by mini-css-extract-plugin
export default {"root":"navbar-module--root--NaR__","active":"navbar-module--active--g8a1D","separator":"navbar-module--separator--YkL4D","uppercase":"navbar-module--uppercase--QuqRL"};